import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function Hero() {
  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <section className="hero" id="top">
      <div className="hero-glow" aria-hidden="true" />

      <div className="hero-inner">
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="section-label">
          <span className="pulse-dot" aria-hidden="true" />
          AI / Applications / Consulting
        </div>

        <h1>
          We solve complex
          <span>problems using AI.</span>
        </h1>

        <p className="hero-copy">
          Practical automation and software solutions built around your real
          needs—not whatever is easiest to sell.
        </p>

        <div className="hero-actions">
          <a
            className="button button-primary"
            href="#contact"
            onClick={(event) => scrollToSection(event, 'contact')}
          >
            Get in touch
            <SafeIcon icon={FiIcons.FiArrowRight} aria-hidden="true" />
          </a>

          <a
            className="button button-ghost"
            href="#services"
            onClick={(event) => scrollToSection(event, 'services')}
          >
            Explore services
          </a>
        </div>
      </motion.div>

      <motion.div
        className="signal-card"
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.25, duration: 0.6 }}
        aria-hidden="true"
      >
        <div className="signal-head">
          <span>Automation activity</span>
          <span className="live-label">Live</span>
        </div>

        <div className="signal-chart">
          {[38, 52, 46, 68, 60, 76, 70, 88, 82, 96].map(
            (height, index) => (
              <motion.i
                key={index}
                style={{ height: `${height}%` }}
                animate={{ scaleY: [1, 0.72, 1] }}
                transition={{
                  duration: 2.4,
                  delay: index * 0.12,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }}
              />
            )
          )}
        </div>

        <div className="signal-footer">
          <div>
            <strong>AI</strong>
            <span>built for your needs</span>
          </div>
          <div>
            <strong>1:1</strong>
            <span>senior attention</span>
          </div>
        </div>
      </motion.div>
      </div>
    </section>
  );
}

export default Hero;